import { render, staticRenderFns } from "./lkuVendor.vue?vue&type=template&id=6011ea4f"
import script from "./lkuVendor.vue?vue&type=script&lang=js"
export * from "./lkuVendor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports